import { FluidPrimitive } from '@lmig/fluid-core';
import { FluidFormElementTranslationOptions } from '@lmig/fluid-core/lib/i18n/types/fluid-form-element-translation-options.interface';
import { FluidDate } from '@lmig/fluid-core/lib/structs/types/fluid-date.type';
import { h } from '@stencil/core';

import { ValidationMessage } from '../../../common/fluid-common-form.components';
import {
  FluidDatepickerCustomEvent,
  FluidI18nStore,
} from '../../../components';
import { INVALID_DATE_RANGE } from '../../../constants/constants';

export interface DateRange {
  from: string;
  to: string;
}

export interface DateRangeFieldProps {
  setRef: (el: HTMLFluidDatepickerElement) => void;
  handleRangeChange: (dataPath: string, val: CustomEvent<any>) => void;
  label: string;
  dataPath: string;
  minDate: FluidDate;
  maxDate: FluidDate;
  fluidTranslate?: FluidFormElementTranslationOptions;
  identifier?: string;
  disabled?: boolean;
  initialValue?: string;
}

export const DateRangeField = (props: DateRangeFieldProps) => {
  const {
    setRef,
    handleRangeChange,
    minDate,
    maxDate,
    label,
    dataPath,
    fluidTranslate,
    identifier,
    disabled,
    initialValue,
  } = props;
  return (
    <fluid-grid-item col={6}>
      <fluid-datepicker
        ref={(element: HTMLFluidDatepickerElement) => setRef(element)}
        identifier={identifier}
        fluidTranslate={fluidTranslate}
        config={{
          label,
          disabled,
          dataPath,
          initialValue: initialValue || (minDate as FluidPrimitive),
          minDate,
          maxDate,
          inlineField: true,
        }}
        onValueChange={(val: FluidDatepickerCustomEvent<any>) =>
          handleRangeChange(dataPath, val)
        }
      />
    </fluid-grid-item>
  );
};

interface InvalidateDateMessageProps {
  doRender: boolean;
  fluidTranslate?: string;
  i18nStore?: FluidI18nStore;
}
export const InvalidDateMessage = (props: InvalidateDateMessageProps) => {
  const { doRender, fluidTranslate, i18nStore } = props;
  return (
    <fluid-grid-item class={'invalid-date'}>
      <ValidationMessage
        visible={doRender}
        errorMessage={
          i18nStore?.translate(fluidTranslate) || INVALID_DATE_RANGE
        }
      />
    </fluid-grid-item>
  );
};
